
import React from "react";

function EditGroupe ({profDetail, editingGroupe , handleNomGroupeChange, handleProfChange, professeur,  nomGroupe, handleUpdateGroupe, handleEditMode}) {

                return( <tr className="bg-sky-700 border-2 border-black  text-center ">
                  <td> </td>
                    <td className=" 2xl:px-5 2xl:py-5 p-2">
                      <div className={`2xl:w-14 w-10 h-10 2xl:h-14 flex items-center justify-center rounded-full font-bold text-white ${
                        editingGroupe.niveau === "6eme" ? "bg-blue-500" : "bg-green-500"
                      }`}>
                        {editingGroupe.niveau === "6eme" ? "6e" : "5e"}
                      </div>
                    </td>

                      <td>
                        <input type="text" onChange={handleNomGroupeChange} value={nomGroupe ? nomGroupe : editingGroupe.nom} placeholder="Nom du groupe" className="  ml-5 bg-transparent border-2 border-black 
                       2xl:text-base text-xs  rounded-3xl 2xl:px-5 2xl:py-5 p-2 
                       bg-white 2xl:w-fit w-36 placeholder:text-base placeholder:text-zinc-700"/>
                      </td>
                    
                      <td>    <select
                value={professeur}
                onChange={handleProfChange}
                className="bg-white border 2xl:text-base text-xs  rounded-3xl 2xl:px-5 2xl:py-5 p-2   2xl:w-fit w-36 border-black  text-zinc-700 focus:border-teal-700 "
            >
                <option value="" disabled>Sélectionnez le professeur...</option>
                {profDetail.map((professor) => (
                    <option key={professor.id} value={professor.id}>
                        {professor.nom} {professor.prenom}
                    </option>
                ))}
            </select>  </td>
                    
                     <td> </td>
                     <td>
                     {(professeur && (nomGroupe || editingGroupe.nom)) && <p onClick={handleUpdateGroupe} className=" 2xl:p-5 p-2 bg-gradient-to-r from-orange-400 to-orange-600 w-fit rounded-3xl shadow-lg 2xl:text-base text-xs font-bold   
                      hover:border-orange-800 hover:border-2 hover:box-border hover:shadow-md hover:shadow-white hover:bg-transparent hover:cursor-pointer
                      hover:scale-105 hover:duration-200" >Modifier </p> }
                         </td>
                <td className="  ">
                    <div className="flex flex-row gap-5">
                   
                    <p  onClick={handleEditMode} className="2xl:p-5 p-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white w-fit rounded-3xl shadow-lg 2xl:text-base text-xs font-bold hover:from-orange-600 hover:to-orange-700 hover:cursor-pointer
                     hover:shadow-xl hover:shadow-orange-500/50
                     hover:scale-105 hover:duration-200">Annuler </p> 
                    </div> 
                </td>

               
                  </tr>
    )
}

export default EditGroupe;